import React from 'react';
import styles from './PasswordRequirements.module.scss';

// The Cognito pool's password policy, checked as the user types.
export interface PasswordCheck {
    minLength: boolean;
    hasUpperCase: boolean;
    hasLowerCase: boolean;
    hasDigit: boolean;
    hasSpecialChar: boolean;
}

export const checkPassword = (password: string): PasswordCheck => ({
    minLength: password.length >= 10,
    hasUpperCase: /[A-Z]/.test(password),
    hasLowerCase: /[a-z]/.test(password),
    hasDigit: /\d/.test(password),
    hasSpecialChar: /[!@#$%^&*()_+\-=[\]{}();':"\\|,.<>/?]/.test(password),
});

export const passwordOk = (password: string): boolean => Object.values(checkPassword(password)).every(Boolean);

const RULES: { key: keyof PasswordCheck; text: string }[] = [
    { key: 'minLength', text: 'At least 10 characters' },
    { key: 'hasUpperCase', text: 'At least one uppercase letter' },
    { key: 'hasLowerCase', text: 'At least one lowercase letter' },
    { key: 'hasDigit', text: 'At least one digit' },
    { key: 'hasSpecialChar', text: 'At least one special character' },
];

const PasswordRequirements: React.FC<{ password: string }> = ({ password }) => {
    const check = checkPassword(password);
    return (
        <div className={styles.passwordRequirements}>
            <p>Password requirements:</p>
            <ul>
                {RULES.map(({ key, text }) => (
                    <li key={key} className={check[key] ? styles.valid : ''}>
                        {check[key] ? '✓' : '○'} {text}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PasswordRequirements;
